<router-outlet />
<ngx-ui-loader fgsColor="#F2B818"></ngx-ui-loader>
<!-- <div *ngIf="message;">
  <h1>{{ message.notification.title }}</h1>
  <h2>{{ message.notification.body }}</h2>
</div>
<div *ngIf="!message;">
  No Message Arrived
</div> -->
